export default "__VITE_ASSET__DbcCmYik__"